export const getParams = (key: string) => {
  return new URLSearchParams(location.search).get(key) || '';
};

export const getAllParams = () => {
  const params = new URLSearchParams(location.search);
  const result: Record<string, string> = {};

  for (const [key, value] of params.entries()) {
    result[key] = value;
  }

  return result;
};
